import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useNavScroll } from '../../hooks/useNavScroll'
import logoImg from '../../assets/Augmentappz LLogo with text.png'

const NAV_SECTIONS = ['hero', 'platform', 'vision', 'journey']

/**
 * Navbar — fixed top navigation with:
 *   - AugmentAppz logo (left)
 *   - Core Offering, About Us links + Talk to Us CTA (right)
 *   - Scroll-aware backdrop blur
 *   - Mobile hamburger menu
 */
export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false)
  const { scrolled, activeSection } = useNavScroll(NAV_SECTIONS)

  const toggleMenu = () => setMenuOpen((prev) => !prev)
  const closeMenu = () => setMenuOpen(false)

  return (
    <header className={`nav-wrapper${scrolled ? ' scrolled' : ''}`} id="nav">
      <nav className="nav-inner container">
        {/* Logo */}
        <a href="/" className="nav-logo" aria-label="AugmentAppz Home">
          <img src={logoImg} alt="AugmentAppz" className="nav-logo-img" />
        </a>

        {/* Desktop links */}
        <ul className="nav-links" role="list">
          <li>
            <a
              href="/#platform"
              className={`nav-link${activeSection === 'platform' ? ' active' : ''}`}
            >
              Core Offering
            </a>
          </li>
          <li>
            <Link to="/about" className="nav-link">
              About Us
            </Link>
          </li>
        </ul>

        {/* CTA */}
        <div className="nav-cta">
          <Link to="/contact" className="btn btn-primary btn-sm">
            Talk to Us
          </Link>
        </div>

        {/* Hamburger */}
        <button
          className="nav-hamburger"
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
          onClick={toggleMenu}
        >
          <span />
          <span />
          <span />
        </button>
      </nav>

      {/* Mobile drawer overlay */}
      {menuOpen && (
        <div
          className="nav-drawer-overlay"
          aria-hidden="true"
          onClick={closeMenu}
        />
      )}

      {/* Mobile menu */}
      <div
        className={`nav-mobile${menuOpen ? ' open' : ''}`}
        aria-hidden={!menuOpen}
      >
        {/* Close button — top-left of the drawer */}
        <button
          className="nav-drawer-close"
          aria-label="Close menu"
          onClick={closeMenu}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
        <ul role="list">
          <li>
            <a href="/#platform" className="nav-link" onClick={closeMenu}>
              Core Offering
            </a>
          </li>
          <li>
            <Link to="/about" className="nav-link" onClick={closeMenu}>
              About Us
            </Link>
          </li>
          <li>
            <Link
              to="/contact"
              className="btn btn-primary btn-sm nav-mobile-btn"
              onClick={closeMenu}
            >
              Talk to Us
            </Link>
          </li>
        </ul>
      </div>
    </header>
  )
}
